import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { Exercise } from './../../entities/exercise/exercise';
import { PseudoRandomGenerator } from './pseudorandomgenerator';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class UniquePseudoRandomFilter implements IExerciseSelectionFilter {
    public static selectUniquePseudoRandomly(inputExercises: Exercise[],
                                             workoutStartDate: Date): Exercise {
        if (inputExercises.length < 1) {
            throw new Error('Input exercises must be at least 1 to select a unique one');
        }
        const seed = PseudoRandomGenerator.getSeedFromDate(workoutStartDate);
        const randomIndex
            =  UniquePseudoRandomFilter.arrayIndexForZeroToOneRandomNumber(
                PseudoRandomGenerator.pseudoRandom(seed),
                inputExercises.length);

        return inputExercises[randomIndex];
    }

    // randomly zero indexed array index
    private static arrayIndexForZeroToOneRandomNumber(random: number, arrayLength: number) {
        return Math.floor(random * arrayLength);
    }

    public description: string = 'Return only one unique exercise randomly, but always the same on a day';
    public name: string = 'UniquePseudoRandomFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[],
                  workoutStartDate: Date): Exercise[] {
        return [UniquePseudoRandomFilter.selectUniquePseudoRandomly(inputExercises, workoutStartDate)];
    }

}
